/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/inbox/supplierInvoicesInbox/bulkTasksHelper"/>

export const normalizeBulkWizardTask = (serverTasks: any[], originalTasks?: any[]) => {
    const documentTypeByTaskId: { [taskId: number]: string } = {};
    (originalTasks || []).forEach((t: any) => {
        const id = Number(t?.taskId);
        if (!isNaN(id) && t?.documentType) {
            documentTypeByTaskId[id] = t.documentType;
        }
    });

    return serverTasks
        .map((task) => {
            const normalizedTaskId = Number(task.TaskId ?? task.id);
            const normalizedDocumentId = Number(task.DocumentId ?? task.documentId);

            const rawDocumentType = task.DocumentType ?? task.documentType ?? task?.taskGroup?.fullName ?? null;
            const resolvedDocumentType = documentTypeByTaskId[normalizedTaskId] || rawDocumentType;
            const description = task.TaskDescription ?? task.taskDescription ?? null;
            const indicators = task.Indicators ?? task.indicators ?? [];

            const normalizedTask: any = {
                ...task,
                id: normalizedTaskId,
                TaskId: normalizedTaskId,
                DocumentId: normalizedDocumentId,
                DocumentType: resolvedDocumentType,
                documentType: resolvedDocumentType,
                Activity: task.Activity,
                TaskDescription: description,
                taskDescription: description,
                Indicators: indicators,
                indicators
            };

            if (!normalizedTask.taskGroup) {
                normalizedTask.taskGroup = { fullName: resolvedDocumentType };
            } else if (!normalizedTask.taskGroup.fullName) {
                normalizedTask.taskGroup.fullName = resolvedDocumentType;
            } else if (resolvedDocumentType) {
                normalizedTask.taskGroup.fullName = resolvedDocumentType;
            }

            return normalizedTask;
        })
        .filter((task) => !!task);
};